<template>
  <div class="course-particulars">
    <div class="course-particulars__title">
      课程详情
    </div>
    <div ref="courseIntruduce" class="course-particulars__contanier">
      <!--课程介绍-->
      <div v-if="brochureModule.brochures" class="recruit-students" style="height: 100%;">
        <!-- <h3>课程简介</h3> -->
        <iframe
          v-if="isURL(brochureModule.brochures)"
          width="100%"
          id="iframeId"
          height="100%"
          scrolling="no"
          :src="brochureModule.brochures"
          frameborder="0"
        ></iframe>
        <div
          v-else
          v-html="htmlData(brochureModule.brochures)"
          ref="imgBox"
          class="description-link description__img"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import xss from 'xss'
export default {
  props: {
    brochureModule: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      ready: false
    }
  },
  beforeMount() {
    window.addEventListener('message', this.postMsgCallback)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.postMsgCallback)
  },
  mounted () {
    this.ready = true
  },
  watch: {
    courseDetail: {
      deep: true,
      handler () {
        if (this.ready) {
          this.$nextTick(() => {
            const imgBox = this.$refs.imgBox
            if (!imgBox) return
            const imgs = imgBox.querySelectorAll('img');
            [...imgs].forEach((item) => item.style.width = '100%')
          })
        }
      },
    }
  },
  methods: {
    postMsgCallback(e) {
      if (e && e.data && e.data.act === 'set_frameheight') {
        let height = e.data.data.height || 1200
        if (window.frames.iframeId) {
          window.frames.iframeId.style.height = height + 'px'
        }
      }
    },
    isURL(val) {
      return val && val.indexOf('http') !== -1 && val.indexOf('<') === -1
    },
    htmlData(val) {
      if (val) {
        return xss(val.replace(/\r\n/g, '<br />').replace(/\n/g, '<br />'))
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
@import 'src/scss/entry';
// @import 'src/views/CourseDetail/index.scss';
// @import 'src/views/CourseDetail/common.scss';
@include b(course-particulars) {
  // width: 788px;
  margin-top: 40px;
  @include e(title) {
    font-size: 18px;
    color: #333333;
    line-height: 24px;
  }
  @include e(contanier) {
    width: 100%;
    // padding: 0 15px;
    min-height: 600px;
    margin-top: 28px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/modules/CourseParticulars.vue